import { useEffect } from 'react';
import { UserAttributeKeys } from '../../userAttributes';
import { useUserAttribute } from '../../userAttributes/userAttributesQueries';
import enviro from 'enviro';
import Raven from 'raven-js';
// @ts-expect-error Could not find a declaration file for module 'feedback-loader/useFeedbackLoader'.
import { useFeedbackLoader } from 'feedback-loader/useFeedbackLoader';
const SURVEY_ID_PROD = 1134;
const SURVEY_ID_QA = 429;
export const ShortsSurvey = () => {
  const {
    loadSurvey,
    clientLoaded
  } = useFeedbackLoader();
  const {
    userAttribute: hasViewedShortSurvey,
    setUserAttribute: setHasViewedShortSurvey,
    userAttributeLoading: hasViewedShortSurveyLoading,
    userAttributesError: hasViewedShortSurveyError
  } = useUserAttribute(UserAttributeKeys.HAS_VIEWED_SHORT_SURVEY);
  useEffect(() => {
    if (hasViewedShortSurvey || hasViewedShortSurveyLoading || hasViewedShortSurveyError || !clientLoaded) {
      return;
    }
    loadSurvey(enviro.isQa() ? SURVEY_ID_QA : SURVEY_ID_PROD, 'CSAT');
    setHasViewedShortSurvey(true).catch(Raven.captureException.bind(Raven));
  }, [hasViewedShortSurvey, hasViewedShortSurveyLoading, hasViewedShortSurveyError, clientLoaded, loadSurvey, setHasViewedShortSurvey]);
  return null;
};